var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.712,
    height: 13.262,
    viewBox: "0 0 24.712 13.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19139",
    "data-name": "Path 19139",
    d: "M14.386,13.744a6.723,6.723,0,0,1-7.208,5.49,6.623,6.623,0,0,1,0-13.215,6.72,6.72,0,0,1,7.21,5.513H25.712v2.212H23.466v4.425H21.219V13.744H18.973v4.425H16.726V13.744ZM7.74,17.062a4.425,4.425,0,1,0-4.493-4.425A4.459,4.459,0,0,0,7.74,17.062Z",
    transform: "translate(-1 -5.994)",
    fill: "#6d6e6f",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.9cebfbbef25b83ad8ac1c130901db5ee.svg";
export { ForwardRef as ReactComponent };